import { combineReducers, configureStore } from "@reduxjs/toolkit";
import cartReducer from "./cart/slice";
import uiReducer from "./ui/slice";
import receiptReducer from "./receipt/slice";
import productReducer from "./product/slice";

const rootReducer = combineReducers({
  cart: cartReducer,
  product: productReducer,
  ui: uiReducer,
  receipt: receiptReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
